import { useTranslation } from 'react-i18next';
import { useApiMutation } from '../../../hooks/useApiMutation';
import { UseApiMutationOptions } from '../../logBooks/types/loogBookTypes';
import { deleteLogbook } from '../api/listApi';

type MutationResponse = { message: string };
type MutationVariables = string;

export const useDeleteLogbook = (
  options?: UseApiMutationOptions<MutationResponse, Error, MutationVariables>,
  invalidateQueryKey?: any
) => {
  const { t } = useTranslation();
  return useApiMutation<MutationResponse, Error, MutationVariables>(deleteLogbook, {
    successMessage: t('logbookConfig.logbookDeletedSuccess', 'Logbook deleted successfully'),
    errorMessage: t('logbookConfig.logbookDeleteFailed', 'Failed to delete logbook'),
    invalidateQueryKeys: [invalidateQueryKey],
    ...options,
  });
};